// router-helpers.js (or beside this file)
export const toPath = (to) => {
  try {
    const u = new URL(to, window.location.origin);
    if (u.origin === window.location.origin) {
      return u.pathname + u.search + u.hash; // strip origin
    }
  } catch {}
  return to;
};
